//Include Both Helper File with needed methods
import {
  getFirebaseAuthToken,
  getFirebaseBackend,
} from "../../../helpers/firebase_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { profileSuccess } from "../profile/reducer";
import { apiError, loginSuccess, reset_login_flag } from "./reducer";
const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const authMe = createAsyncThunk("auth/me", async () => {
  try {
    const token = await getFirebaseAuthToken();
    const response = await fetch(`${API_BASE}/dashboard/auth/me`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Error fetching user");
    }

    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
});

export const loginUser = (user, history) => async (dispatch) => {
  try {
    const fireBaseBackend = getFirebaseBackend();
    const response = await fireBaseBackend.loginUser(user.email, user.password);
    if (response) {
      localStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));
      dispatch(profileSuccess({ data: response }));
      // history("/profile");
    }
  } catch (error) {
    console.log(error);
    dispatch(apiError("Invalid username/password"));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    const fireBaseBackend = getFirebaseBackend();

    fireBaseBackend.logout();
  } catch (error) {
    console.log(error);
    dispatch(apiError(error));
  }
};

export const socialLogin = (type, history) => async (dispatch) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    //  else {
    //   response = postSocialLogin(data);
    // }

    const socialdata = await response;
    if (socialdata) {
      localStorage.setItem("authUser", JSON.stringify(socialdata));
      dispatch(loginSuccess(socialdata));
      dispatch(profileSuccess({ data: socialdata }));
      history("/dashboard");
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
